// Tiny fetch wrapper for the Hono API. Credentials are included so the
// httpOnly session cookie travels with portal requests.

const BASE = ''; // same origin (Vite proxies /api → :4000 in dev)

export async function apiGet<T>(path: string): Promise<T> {
  const r = await fetch(`${BASE}${path}`, { credentials: 'include' });
  if (!r.ok) throw new ApiError(r.status, await safeJson(r));
  return r.json();
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new ApiError(r.status, await safeJson(r));
  return r.json();
}

export async function apiPatch<T>(path: string, body: unknown): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new ApiError(r.status, await safeJson(r));
  return r.json();
}

export async function apiDelete<T>(path: string): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!r.ok) throw new ApiError(r.status, await safeJson(r));
  return r.json();
}

async function safeJson(r: Response): Promise<unknown> {
  try { return await r.json(); } catch { return null; }
}

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`API error ${status}`);
  }
  get code(): string {
    const b = this.body as { error?: { code?: string } } | null;
    return b?.error?.code ?? 'unknown';
  }
  get serverMessage(): string {
    const b = this.body as { error?: { message?: string } } | null;
    return b?.error?.message ?? this.message;
  }
}
